import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { User } from '../_models';
import { Worklog, NewWorklog } from '../_models/worklog';
import { Observable } from 'rxjs';
import { Position } from '../_models/position';

@Injectable()
export class UserService {
  constructor(private http: HttpClient) {}

  getAll(): Observable<User[]> {
    return this.http.get<User[]>(`/api/users`);
  }

  getById(id: number): Observable<User> {
    return this.http.get<User>(`/api/users/${id}`);
  }

  update(user: User): Observable<void> {
    return this.http.patch<void>(`/api/users/${user.id}`, user);
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`/api/users/${id}`);
  }

  create(user: User): Observable<void> {
    return this.http.post<void>(`/api/users`, user);
  }

  acceptGdpr(): Observable<void> {
    return this.http.post<void>(`/api/users/accept-gdpr`, {});
  }

  changePassword(oldPassword: string, password: string): Observable<void> {
    return this.http.post<void>(`/api/users/change-password`, { oldPassword, password });
  }

  addUserWorklog(id: number, worklog: Worklog): Observable<void> {
    return this.http.post<void>(`/api/users/${id}/worklogs`, worklog);
  }

  getUserWorklogs(id: number, filters: { [params: string]: string | string[] }): Observable<Worklog[]> {
    return this.http.get<Worklog[]>(`/api/users/${id}/worklogs`, { params: filters });
  }

  getUserAvailablePositions(id: number): Observable<Position[]> {
    return this.http.get<Position[]>(`/api/users/${id}/positions`);
  }
}
